import axios from "axios";

export const create = ( requestParams, formData, callback ) => {
  let promise = axios({
    method: 'POST',
    url: Routes.laboral_controldoc_form_template_layouts_path({ "format": "json" }),
    data: formData,
    headers: {
      "X-CSRF-TOKEN": window.compliance.token
    }
  });

  promise
    .then(response => {
      callback(response)
    })
    .catch(error => {
      callback(error.response)
    })
};

export const update = (requestParams, formData, callback) => {
  let promise = axios({
    method: 'PATCH',
    url: Routes.laboral_controldoc_form_template_layout_path({ ...{ ... requestParams }, "format": "json", _options: true }),
    data: formData,
    headers: {
      "X-CSRF-TOKEN": window.compliance.token,
    },
  });

  promise
    .then(response => {
      callback(response);
    })
    .catch(error => {
      callback(error.response);
    });
};

export const preview = (requestParams, formData, callback) => {
  let promise = axios({
    method: 'POST',
    url: Routes.preview_laboral_controldoc_form_template_layouts_path(),
    data: formData,
    headers: {
      "X-CSRF-TOKEN": window.compliance.token,
    },
    responseType: 'blob'
  });

  promise
    .then(response => {
      callback(response);
    })
    .catch(error => {
      callback(error.response);
    });
};
